import React, { useMemo } from "react";
import { FixedSizeGrid as Grid } from "react-window";
import { Box } from "@mui/material";
import JobCard from "./JobCard";
import LoadingCircle from "../../../components/LayoutComponents/LoadingCircle";

export default function JobList ({ jobs, session, userComp, loading, isMobile, programs, schools, courses }) {

  const columnCount = isMobile ? 1 : 3; 
  const columnWidth = isMobile ? 360 : 320;
  const rowHeight = 260;

  const rowCount = Math.ceil(jobs.length / columnCount);

  const Cell = useMemo(
    () =>
      ({ columnIndex, rowIndex, style }) => {
        const jobIndex = rowIndex * columnCount + columnIndex;
        if (jobIndex >= jobs.length) return null;
        const job = jobs[jobIndex];

        return (
          <div style={{ ...style, padding: "0.5rem" }}>
            <JobCard
              job={job}
              programs={programs}
              courses={courses}
              isMobile={isMobile}
              userComp={userComp}
              session={session}
              schools={schools.filter(e=>(e.state === job.state))}
              showEditDelete={
                session?.role === "System Administrator" ||
                (session?.role === "Employer" && job?.ownerid === session?.userId)
              }
              onAnalyze={(id) => console.log("Analyze job", id)}
            />
          </div>
        );
      },
    [jobs, columnCount, session, userComp, isMobile, programs, schools, courses]
  );

  if (loading) {
    return (
      <Box
        sx={{
          width: "100%",
          height: "60vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflowY:'hidden'
        }}
      >
        <LoadingCircle />
      </Box>
    );
  }

  return (
    <Grid
      columnCount={columnCount}
      columnWidth={columnWidth}
      height={600}
      rowCount={rowCount}
      rowHeight={rowHeight}
      width={columnWidth * columnCount + 16} // Add some extra width for padding
    >
      {Cell}
    </Grid>
  );
};
